import { render, staticRenderFns } from "./cardProducto.vue?vue&type=template&id=1f46ea04&scoped=true"
import script from "./cardProducto.vue?vue&type=script&lang=js"
export * from "./cardProducto.vue?vue&type=script&lang=js"
import style0 from "./cardProducto.vue?vue&type=style&index=0&id=1f46ea04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46ea04",
  null
  
)

export default component.exports